"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.indicatorIcon = exports.default = void 0;
var _LoadingOutlined2 = _interopRequireDefault(require("@zenlayer/zen-design-icons/assets/LoadingOutlined.svg"));
var _antd = require("antd");
var _classnames = _interopRequireDefault(require("classnames"));
var _react = _interopRequireDefault(require("react"));
var _icon = _interopRequireDefault(require("../icon"));
var _jsxRuntime = require("react/jsx-runtime");
const indicatorIcon = exports.indicatorIcon = /*#__PURE__*/(0, _jsxRuntime.jsx)(_icon.default, {
  type: "LoadingOutlined",
  style: {
    fontSize: 24
  },
  spin: true
});
const Spin = props => {
  const {
    indicator,
    prefixClass = 'zen-design',
    //TODO 写provider时统一改掉
    className,
    wrapperClassName,
    ...restProps
  } = props;
  const baseClassName = "".concat(prefixClass, "-spin");
  const baseWrapperClassName = "".concat(prefixClass, "-spin-wrap");
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_antd.Spin, {
    wrapperClassName: (0, _classnames.default)(baseWrapperClassName, wrapperClassName),
    className: (0, _classnames.default)(baseClassName, className),
    indicator: indicator || indicatorIcon,
    ...restProps
  });
};
var _default = exports.default = Spin;